export default __webpack_public_path__ + "static/media/leconomia.62081c9f.png";